/** Shared MUI typography metrics without importing any next/font (avoids loading unused families). */
export const fontSize = 14;
export const typographyBase = {
  fontSize,
  htmlFontSize: 16,
  body1: {
    fontSize,
  },
  body2: {
    fontSize,
  },
};
